module.exports = __webpack_public_path__ + "static/img/6.e70f68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/6.png
// module id = 3meP
// module chunks = 0